const l = {
  Zipp: "ZIPP",
  ZippAbo: "ZIPP_ABO",
  Others: "OTHERS",
  Full: "FULL"
};
function r(n) {
  return t(n);
}
function t(n, e) {
  return n;
}
function o(n) {
  return n;
}
export {
  l as InstallmentPlanType,
  r as InstallmentPlanTypeFromJSON,
  t as InstallmentPlanTypeFromJSONTyped,
  o as InstallmentPlanTypeToJSON
};
//# sourceMappingURL=InstallmentPlanType.js.map
